import { render, staticRenderFns } from "./admissionNotice.vue?vue&type=template&id=45688796&scoped=true&"
import script from "./admissionNotice.vue?vue&type=script&lang=js&"
export * from "./admissionNotice.vue?vue&type=script&lang=js&"
import style0 from "./admissionNotice.vue?vue&type=style&index=0&id=45688796&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45688796",
  null
  
)

export default component.exports